import { FC } from "react";
import { Text } from "@otrium/atoms";
import { Box, Flex } from "@otrium/core";
import { NativeSelect } from "src/atoms/NativeSelect";
import { getSortByOptions } from "src/organisms/AlgoliaProductList/withAlgoliaState";
import { t } from "@lingui/macro";
import { StatsProvided } from "react-instantsearch-core";
import { connectStats } from "react-instantsearch-dom";
import { useLingui } from "@lingui/react";

interface Props extends StatsProvided {
  sortValue: string;
  handleSelect: (value: string) => void;
}

const MobileSortByFilterComponent: FC<Props> = ({
  sortValue,
  handleSelect,
  nbHits,
}) => {
  const { i18n } = useLingui();

  return (
    <Flex alignItems="center" flexWrap="wrap" justifyContent="flex-end">
      <Box display={["none", "none", "flex", "none"]}>
        {nbHits > 0 && (
          <Text
            fontSize={0}
            mr={1}
            color="tone.anthraciteLight"
            lineHeight={[1.5, 1.43]}
          >
            {i18n.number(nbHits)} {t(i18n)`results`}
          </Text>
        )}
        <Text
          fontSize={0}
          mr={2}
          color="tone.anthraciteLight"
          lineHeight={[1.5, 1.43]}
        >
          {t(i18n)`sort by`}
        </Text>
      </Box>
      <Text
        as="p"
        fontSize={0}
        mr={1}
        color="tone.anthraciteLight"
        lineHeight={[1.5, 1.43]}
        textAlign="right"
        display={["flex", "flex", "none"]}
      >
        {t(i18n)`Sort by`}
      </Text>
      <NativeSelect
        options={getSortByOptions(i18n)}
        value={sortValue}
        handleSelect={handleSelect}
      />
    </Flex>
  );
};

const MobileSortByFilter = connectStats(MobileSortByFilterComponent);

export default MobileSortByFilter;
